window.countryPicker = () => {
    return {
        open: false,

        handleCountryPickerOpen() {
            document.body.classList.add("modal-open");
            this.open = true;
            console.log("run");
        },

        handleCountryPickerClose() {
            document.body.classList.remove("modal-open");
            this.open = false;
        },
    };
};
